import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"
import {
  canEdit,
  getMediaItems,
  getSectionChat,
  getSettings,
} from "@/onboarding/features/product/selectors"
import SectionHolder from "@/onboarding/features/product/components/shared/SectionHolder"

import Content from "./media/Content"

const MediaSection: FC = () => {
  const { tour_images } = useSelector(getSettings(ReservedFields.TOUR_IMAGES))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("tourImages")))
  const editable = useSelector(canEdit)
  const showLockedIcon = !(tour_images?.writeable ?? false) && editable
  const isChanged = tour_images?.changed ?? false
  const isRequired = tour_images?.required ?? false
  const mediaItems = useSelector(getMediaItems)

  return (
    <SectionHolder
      title="Tour Images and Video"
      name={ReservedSections.TOUR_IMAGES}
      importableFields={[ReservedFields.TOUR_IMAGES]}
      showLockedIcon={showLockedIcon}
      missingRequiredComponent={isRequired && _.isEmpty(mediaItems)}
      changedComponent={isChanged}
      chat={sectionChat}
    >
      <Content />
    </SectionHolder>
  )
}

export default MediaSection
